// 德语
import constant from '../../constants/lang/de';
import newLang from '../newLang/de';
/* eslint-disable max-len */
export default {
  cfmoto: {
    ...(newLang.cfmoto || {}),
    constant,
    api: {
      http: {
        401: 'Bitte erst anmelden',
        404: 'Keine Daten',
        500: 'Das System ist beschäftigt, bitte versuchen Sie es später erneut',
        504: 'Anfrage abgelaufen',
        ERR_NETWORK: 'Netzwerk-Ausnahme',
        ERR_NETWORK_UPLOAD: 'Der Upload ist fehlgeschlagen. Bitte versuchen Sie es mit einem anderen Netzwerk',
      },
    },
    title: 'Intemet International',
    navbar: {
      dropdown: {
        updatePassword: 'update password',
        switchLanguage: 'switch language',
        logout: 'log out',
      },
    },
    router: {
      title: {
        'binding-agreement': '绑车协议',
        introduce: '介绍',
        lamp: 'Kontrollleuchte',
        download: 'CFMOTO RIDE APP Download',
        orderConfirm: 'Order Confirmation',
        ebook: 'ebook',
        list: 'ebook',
        pdf: 'PDF',
        feedback: 'Aufzeichnungen',
        'feedback-create': 'Rückmeldungn',
        'feedback-supplement': 'Ergänzendes Feedback',
        'feedback-detail': 'Details zur Rückmeldung',
        'feedback-result': 'Rückmeldung',
        guide: 'Hilfezentrum',
        'guide-restScreen': 'Setup-Anweisungen',
        'guide-overview': 'Überblick über die Funktionen',
        'guide-account': 'Über das Konto',
        'guide-vehicle': 'Über das Fahrzeug',
        'guide-meterSetting': 'Einrichten des Armaturenbretts',
        'guide-vehicleSetting': 'Wie man das Fahrzeug einrichtet',
        'guide-findNavigation': 'Navigieren, um das Fahrzeug zu finden',
        'guide-vehicleNnavigation': 'Wie man die Navigation benutzt',
        'guide-cyclingRecord': 'Über die Fahrtenhistorie',
        'guide-vehicleExperience': 'Wie man eine Selbstinspektion des Fahrzeugs durchführt',
        'guide-useSetting': 'So nehmen Sie allgemeine APP-Einstellungen vor',
        'guide-notice': 'So zeigen Sie Nachrichtenbenachrichtigungen an und stellen sie ein',
        'guide-about': 'Über APP',
        help: 'Hilfe & Feedback',
        'help-detail': 'Fragendetails',
        'myCar-unbinding': 'Entbinden anwenden',
        'myCar-unbinding-result': 'Entbinden anwenden',
      },
    },
    form: {
      cancel: 'Abbrechen',
      confirm: 'Bestätigen Sie',
      submit: 'Absenden',
      search: 'Suche',
      language: {
        languageCode: {
          label: 'select language',
          placeholder: 'please select language',
        },
      },
    },
    rules: {
      language: {
        languageCode: {
          required: 'please select language',
        },
      },
    },
    dialog: {
      language: 'select language',
    },
    binding: {
      title: `Protokoll`,
      text1: '1.	Telematikdienste _',
      text2:
        'CFMOTO Powersports, Inc. (im Folgenden als „ CFMOTO “ bezeichnet ) stellt Fahrzeugtelematikdienste für den Kunden bereit, der das CFMOTO-Fahrzeug gekauft hat (im Folgenden als „Kunde“ bezeichnet ). Für diese Dienste verwendet CFMOTO vom Fahrzeug aufgezeichnete Daten über das Fahrzeug und sein Fahrverhalten im relevanten Zeitraum. Im Einzelnen handelt es sich um folgende Daten:',
      text3: 'Fahrverhaltensdaten des Benutzers : einschließlich Beschleunigung, Verzögerung, Geschwindigkeit, Kurvenfahrt, letzte Fahrzeit und letzte Fahrkilometer .',
      text4:
        'Fahrzeugstatusdaten: Bezieht sich auf den Echtzeitstatus des Fahrzeugs, einschließlich Fahrmodus, Restkraftstoff, sofortiger Kraftstoffverbrauch, Kilometerstand, Echtzeit-Gang des Fahrzeugs, Motordrehzahl, Reifendruck, Reifentemperatur, Batterieaktivierungsspannungsdaten , Kühlmitteltemperatur, Status der elektronischen Sperre, Softwareversion des intelligenten Geräts, Signalstärke von Smart Devices, aktuelle Einstellung des Dashboards.',
      text5:
        'Fahrzeugalarmdaten: Alarmdaten, die gesendet werden, wenn bestimmte Daten einen voreingestellten Wert überschreiten, wie z. B. Motortemperatur, überhöhte Geschwindigkeit, überhöhte Fahrzeit, hohe Kühlmitteltemperatur, anormale Fahrzeugbewegung, anormaler Reifendruck, Vibration, Kippen, Zusammenstoß usw .',
      text6: 'Fahrzeugfehlerinformationen: bezieht sich auf die Fehlercodes, die von jedem internen Teil des Fahrzeugs gemeldet werden.',
      text7: 'Fahrzeugstandortdaten: bezieht sich auf den spezifischen geografischen Aufenthaltsort des Fahrzeugs.',
      text8: '1.1.	Bereitstellen _ den Kunden mit fahrzeugbezogenen Diensten über die CFMOTO RIDE APP .',
      text9: '1.1.1.	APP fernverwalten (einschließlich Anzeigen des Fahrzeugstandorts, Einstellen der Fahrzeuginformationen und -funktionen, Fernsteuerung des Fahrzeugstatus usw.).',
      text10: '1.1.2.	Bereitstellen von Routenplanung während der Navigation, einschließlich Berechnung der Entfernung zwischen Fahrzeugen und Fußgängernavigation zum Auffinden eines Fahrzeugs .',
      text11: '1.2.	Senden der erforderlichen Benachrichtigungen an den Kunden basierend auf den Bedingungen des Fahrzeugs.',
      text12:
        '1.2.1.	CFMOTO sendet dem Kunden Benachrichtigungen zur Fahrzeugwartung (z. B. basierend auf der Gesamtstrecke, die der Kunde zurückgelegt hat, dem Zeitpunkt, zu dem der Kunde das Fahrzeug gekauft hat, der Zeit oder der erforderlichen Fahrstrecke für die Fahrzeugwartung) .',
      text13: '1.2.2.	Basierend auf Fahrzeugdaten sendet CFMOTO dem Kunden Benachrichtigungen über ungewöhnliche Situationen; inkl. Datenanalyse durch OEM (je nach Modell) zur Kundenbetreuung und Folgeoptimierung des Fahrzeugs .',
      text14: '1.3.	Unterstützung bei der Analyse der Unfallursache, wenn der Kunde einen schweren Unfall des Fahrzeugs meldet.',
      text15:
        '1.3.1.	Im Falle eines schweren Unfalls des Fahrzeugs, etwa wenn sich das Fahrzeug während der Fahrt überschlägt oder auf die Seite kippt, unterstützt CFMOTO den Kunden auf Wunsch bei der Klärung, ob der Unfall auf einen Mangel des Fahrzeugs oder andere Umstände zurückzuführen ist. Die Anfrage ist vom Kunden über den im Fahrzeugverkaufsvertrag angegebenen lokalen Distributor / Vertriebspartner an CFMOTO zu richten.',
      text16: '1.3.2.	Soweit die verfügbaren Daten dies zulassen, wird CFMOTO die Daten im Hinblick auf die Unfallursache auswerten und dem Kunden einen entsprechenden Bericht zukommen lassen.',
      text17: '1.4.	Unterstützung des Kunden bei der Wiedererlangung des Fahrzeugs nach Fahrzeugverlust .',
      text18:
        '1.4.1.	Bei Verlust des Fahrzeugs stellt CFMOTO dem Kunden auf Anfrage und sofern verfügbar Standortdaten des Fahrzeugs und andere nützliche Statusdaten des Fahrzeugs (z. B. Ort der letzten Aktivierung, aktueller Fahrzeugstatus usw.) zur Verfügung.',
      text19: '1.4.2.	Die Anfrage ist vom Kunden über den im Fahrzeugverkaufsvertrag angegebenen lokalen Distributor / Vertriebspartner an CFMOTO zu richten.',
      text20: '1.5.	Meldung von After-Sales-Problemen .',
      text21:
        '1.5.1.	CFMOTO sammelt aus der Ferne Fehlercode-Benachrichtigungen, die vom Fahrzeug im Falle einer Fehlfunktion seiner Komponenten gesendet werden, und stellt entsprechende Informationen auf Anfrage des Kunden direkt dem Kunden zur Verfügung.',
      text22: '1.5.2.	Die Anfrage ist vom Kunden über den im Fahrzeugverkaufsvertrag angegebenen lokalen Distributor / Vertriebspartner an CFMOTO zu richten.',
      text23: '2.	Einschränkungen und Ausschlüsse des Dienstes',
      text24:
        '2.1.	Es wird ausdrücklich darauf hingewiesen, dass bauliche oder sonstige technische Änderungen am Fahrzeug die Bereitstellung der Dienste einschränken oder sogar unmöglich machen können, da die Dienste von der korrekten Bereitstellung der Fahrzeugdaten abhängig sind.',
      text25: '2.2.	Wenn solche Dienste aufgrund der Leistung von Daten- oder Telekommunikationsnetzen Dritter nicht erbracht werden können, ist jegliche Haftung von CFMOTO ausgeschlossen .',
      text26: '3.	Privatsphäre',
      text27:
        'dem CFMOTO- Fahrzeug die geltenden Datenschutzbestimmungen einhalten . Die Bedingungen der Datenschutzrichtlinie von C FMOTO sind in dieser CFMOTO RIDE APP dargelegt . Als Ergänzung zur Datenschutzerklärung entspricht dieser Hinweis der Datenschutzerklärung . Und der Kunde kann sich auf die Datenschutzerklärung für einige datenverarbeitungsbezogene Inhalte beziehen, die nicht von dieser Erklärung abgedeckt sind.',
      text28: '4.	Kundendienst',
      text29:
        '4.1.	Der Kunde kann gerne datenschutzbezogene Fragen, Kommentare oder Bedenken an CFMOTORIDEAPP@cfmotousa.com senden oder an folgende Adresse schreiben: CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, M N 55447. Der Kunde kann auch anrufen CFMOTO-Kundendienst unter (888) 823-6686. ',
      text30: '5.	Revisionen _',
      text31: '5.1.	CFMOTO behält sich das Recht vor, diese Mitteilung jederzeit zu ändern, aber wir werden Überarbeitungen auf CFMOTO RIDE veröffentlichen App und/oder Benachrichtigung, bevor wir dies tun, sofern angemessen.',
    },
    atmosphere: {
      desTitle: '功能说明',
      setINfo: 'Die neuen Einstellungen werden innerhalb von 1-3 Minuten nach dem Einschalten des Fahrzeugs wirksam, bitte stellen Sie sicher, dass sich das Fahrzeug in einer guten Signalposition befindet',
      setSuccess: 'Erfolgreich eingestellt',
      sure: 'Na klar',
      confirm: 'Bestätigen',
      cancel: 'Abbrechen',
      cContent: 'Die Einstellungen wurden noch nicht gespeichert, möchten Sie sie speichern?',
      save: 'Einstellungen speichern',
      introduce1: 'In der Nähe von Anweisungen zum automatischen Entsperren',
      introduce2: 'Anweisungen zum automatischen Ausschalten',
      introduce3: 'Anweisungen zum automatischen Aufwachen',
      introduce4: 'Verzögertes Ausschalten der Lichter',
      content1: {
        msg1: 'Nach dem Einschalten der Funktion schaltet das Mobiltelefon Bluetooth ein und die APP läuft weiter. Bei Annäherung an das Fahrzeug von nah nach fern kann das Fahrzeug automatisch entriegelt und eingeschaltet werden.',
        msg2: 'Wenn es normalerweise nicht entriegelt und eingeschaltet ist, drücken Sie zum Entriegeln und Einschalten den Netzschalter des Fahrzeugs',
        msg3: 'Die automatische Proximity-Entsperrung wird nur einmal ausgelöst, bevor die Bluetooth-Verbindung getrennt wird.',
      },
      content2: {
        msg1: 'Nach dem Einschalten der Funktion schaltet sich das Fahrzeug nach 5 Sekunden automatisch aus, nachdem die drei Bedingungen des Abschaltens des Fahrzeugs erfüllt sind, die Fahrzeuggeschwindigkeit 0 beträgt und der Bügel heruntergelassen wurde',
        msg2: 'Wenn das Fahrzeug während der automatischen Abschaltzeit gestartet wird, die Fahrzeuggeschwindigkeit nicht 0 ist oder der Bügel weggelegt wird, wird die automatische Abschaltung abgebrochen',
      },
      content3: {
        msg1: 'Nach dem Einschalten der Funktion schaltet das Mobiltelefon beim Ausschalten des Fahrzeugs Bluetooth ein und die APP läuft weiter oder trägt den physischen Schlüssel.Wenn Sie sich dem Fahrzeug von weit nach nah nähern, blinken die Fahrzeuglichter, um Gäste willkommen zu heißen',
        msg2: 'Um zu verhindern, dass häufiges Auslösen zu einem Stromausfall des Fahrzeugs führt, wird die Willkommensfunktion, nachdem sie innerhalb von 30 Sekunden zweimal ausgelöst wurde, erst 30 Minuten später wieder aufgenommen',
      },
      content4: {
        msg1: 'Nachdem die Funktion eingeschaltet wurde, werden die Fern- und Abblendlichter automatisch für 10 Sekunden eingeschaltet, nachdem das Fahrzeug ausgeschaltet wurde',
      },
    },
    feedback: {
      label: {
        type: 'Feedbacktyp (Einfachauswahl)',
        content: 'Beschreibung des Problems',
        fileList: 'Bitte laden Sie ein Bild',
        fileList2: '(Maximal 4 Bilder / 1 Video)',
        feedbackCreate: 'Zum Feedback klicken',
        feedbackSupplement: 'Zusätzliches Feedback',
        backHome: 'Zurück zur Startseite',
        vehicle: 'dazugehöriges Fahrzeug',
        selectVehicle: 'Fahrzeug auswählen',
      },
      placeholder: {
        'content.bug': 'Bitte beschreiben Sie detailliert den Zeitpunkt des Auftretens, die APP-Version, das Handymodell, den Betriebsweg und die Problembeschreibung, um das Problem schnell zu finden und zu beheben!',
        'content.suggest': 'Wir freuen uns über wertvolle Vorschläge und werden Ihre Ideen ernsthaft prüfen.',
        'content.vehicle': 'Beschreiben Sie bitte, wann und wie es passiert ist und welches Problem vorliegt',
        'content.other': 'Beschreiben Sie bitte, wann und wie es passiert ist und welches Problem vorliegt',
        'content.supplement': 'Bitte fügen Sie eine Beschreibung des Problems hinzu',
        vehicle: 'Bitte wählen Sie ein Fahrzeug aus',
      },
      rules: {
        'type.required': 'Bitte wählen Sie einen Feedback-Typ aus',
        'content.required': 'Bitte geben Sie eine Beschreibung Ihres Problems ein',
        'fileList.uploading': 'Hochladen, bitte warten',
        'fileList.maxSize': 'Die hochgeladene Datei ist zu groß',
        'fileList.overType': 'Nicht unterstütztes Format',
        'fileList.maxCount': 'Die Anzahl der Uploads überschreitet das Limit',
        'fileList.acceptImageVideo': 'Video kann bei der Auswahl von Bildern nicht ausgewählt werden',
        'vehicle.required': 'Bitte wählen Sie ein Fahrzeug aus',
      },
      message: {
        empty: 'Zurzeit gibt es keine Rückmeldungen.',
        finish: 'Alles hier drin',
        loading: 'Laden',
        uploadFailed: 'Hochladen fehlgeschlagen',
        tip: 'Um die Sicherheit Ihres Kontos zu schützen, übermitteln Sie hier bitte keine sensiblen persönlichen Daten, wie z. B. Kontopasswörter usw.',
        feedbackSuccess: 'Rückmeldung erhalten',
        'submit.error': 'Feedback fehlgeschlagen',
        'submit.success': 'Rückmeldung erhalten',
      },
    },
    guide: {
      label: { giveFeedback: 'Ungelöst, ich möchte Feedback geben' },
    },
    help: {
      label: {
        history: 'Suchdatensätze durchsuchen',
        cancel: 'Absagen',
        yes: 'Ja',
        no: 'Nein',
        unresolved: 'Können Sie das Problem immer noch nicht lösen? Klicken',
        submitFeedback: 'Feedback abgeben',
      },
      placeholder: {
        search: 'Suche',
        'content.required': 'Bitte Schlüsselwort eingeben',
      },
      message: {
        empty: 'Kein verwandter Inhalt',
        empty2: 'Schlagen Sie vor, Schlüsselwörter zu ändern oder',
        finish: 'Alles hier drin',
        historyDelete: 'Alle Suchdatensätze löschen?',
        isHelpful: 'Hilft es?',
      },
    },
    unbinding: {
      label: {
        vin: 'Kennnummer',
        realName: 'Ihr voller Name',
        email: 'E-Mail Adresse',
        phone: 'Telefon-Nummer',
        areaCode: 'Landesvorwahl',
        identity: 'Identifizierung',
        drivingLicense: 'Fahrzeugzulassungsbescheinigung',
        backHome: 'Zurück zur Startseite',
        areaCodeTitle: 'Landescode',
        latterTitle: 'Notiz',
        agree: 'Freigabe',
        disagree: 'Nicht zustimmen',
        agreeCheckLabel: 'Ich habe gelesen und bin einverstanden mit',
        agreeCheckTitle: 'Anleitung zur Beantragung der Fahrzeugfreigabe',
      },
      placeholder: {
        vin: 'Bitte geben Sie die VIN ein',
        realName: 'Bitte geben Sie Ihren richtigen Namen ein',
        email: 'Bitte geben Sie Ihre E-Mail Adresse ein',
        phone: 'Bitte geben Sie Ihre Telefonnummer ein',
        identity: 'Hauptseite des Personalausweises, Führerscheins oder Reisepasses mit Angaben zur persönlichen Identifizierung',
        drivingLicense: 'Fahrzeugschein-Hauptseite mit dem Namen des Besitzers und der VIN',
      },
      rules: {
        'agree.required': 'Bitte lesen und zustimmen',
        'vin.required': 'Bitte geben Sie die VIN ein',
        'vin.pattern': 'Falsche Fahrzeugidentifikationsnummer (VIN), bitte überprüfen Sie.',
        'realName.required': 'Bitte geben Sie Ihren richtigen Namen ein',
        'email.required': 'Bitte geben Sie Ihre E-Mail Adresse ein',
        'email.pattern': 'Das Format der E-Mail-Adresse ist falsch, bitte überprüfen Sie es',
        'phone.required': 'Bitte geben Sie Ihre Telefonnummer ein',
        'phone.pattern': 'Formatfehler der Telefonnummer, bitte überprüfen',
        'fileList.maxCount': 'Die Anzahl der Uploads überschreitet das Limit',
        'fileList.uploading': 'Hochladen, bitte warten',
      },
      message: {
        imgUploadFailed: 'Bild hochladen fehlgeschlagen',
        securityMessage: 'Die oben genannten Informationen werden nur zur Identitätsprüfung verwendet, CFMOTO schützt Ihre Daten',
        resultMessage: 'Wir werden die Bewerbungsunterlagen so schnell wie möglich überprüfen. Bitte achten Sie rechtzeitig auf die Benachrichtigungsleiste oder das APP-Nachrichtencenter.',
        loading: 'Laden',
      },
    },
  },
};
